export const instructionSheetNONAvalara = {
  name: "Instructions",
  columns: [{ autoWidth: true }, { autoWidth: true }],
  rows: [
    {
      height: 40,
      cells: [
        {
          value: "Pointers to note",
          bold: true,
          fontSize: 16,
          background: "#1E3A8A",
          color: "#FFFFFF",
          textAlign: "center",
          verticalAlign: "center",
          colSpan: 2,
        },
      ],
    },

    {
      cells: [
        { value: "1" },
        {
          value:
            "Using this import sheet, administrative user would be able to create product metadata in bulk",
        },
      ],
    },
    {
      cells: [
        { value: "2" },
        {
          value: `Download the "Sample Import Template" from the DGrab admin [Master data > Products > Import]`,
        },
      ],
    },
    {
      cells: [
        { value: "3" },
        {
          value: `Fields marked with "*" [Asterisk] symbol are mandatory parameters required for creation of product onto the system`,
        },
      ],
    },
    {
      cells: [
        { value: "5" },
        {
          value: `Do not rename/tamper the sheet names as well as the column names in the import template`,
        },
      ],
    },

    {
      cells: [
        { value: "6", bold: true },
        {
          value: "Brief on parameters specific to product:",
          bold: true,
        },
      ],
    },

    {
      cells: [
        "",
        "Item ID* - Unique reference number specific to a product",
      ].map((v) => ({ value: v })),
    },
    {
      cells: [
        "",
        "Stockcode[SKU]* - SKU uniquely specific to a sellable SKU attribute of a product",
      ].map((v) => ({ value: v })),
    },
    {
      cells: [
        "",
        "Barcode Type* - Barcode type associated to a product",
      ].map((v) => ({ value: v })),
    },
    {
      cells: [
        "",
        "Barcode Value* - Barcode value associated to a product",
      ].map((v) => ({ value: v })),
    },
    {
      cells: [
        "",
        "Item Title* - Product title (Brand - Product name - SKU)",
      ].map((v) => ({ value: v })),
    },
    {
      cells: [
        "",
        "Tax code* - Integrated with Avalara for tax related data",
      ].map((v) => ({ value: v })),
    },
    {
      cells: ["", "Media: Image - Image location / URL"].map((v) => ({
        value: v,
      })),
    },
    {
      cells: ["", "Associate location - Stores/Outlet mapping"].map((v) => ({
        value: v,
      })),
    },
    {
      cells: ["", "Item Hierarchy - Category mapping"].map((v) => ({
        value: v,
      })),
    },
    { cells: ["", "Brand* - Brand name"].map((v) => ({ value: v })) },
    { cells: ["", "Unit of Measure (UOM)"].map((v) => ({ value: v })) },
    {
      cells: ["", "Item storage* - Storage instruction"].map((v) => ({
        value: v,
      })),
    },
    { cells: ["", "Item weight*"].map((v) => ({ value: v })) },
    {
      cells: ["", "Item dimension [Height, Width, Depth]"].map((v) => ({
        value: v,
      })),
    },
    {
      cells: ["", "Item package dimension [Height, Width, Depth]"].map((v) => ({
        value: v,
      })),
    },
    {
      cells: ["", "Manufacturer* - Manufacturer information"].map((v) => ({
        value: v,
      })),
    },
    {
      cells: ["", "Product specification - Key-pair values"].map((v) => ({
        value: v,
      })),
    },
    {
      cells: ["", "Attributes - Key-pair customized values"].map((v) => ({
        value: v,
      })),
    },

    {
      cells: [
        { value: "7" },
        {
          value: "Option to upload an import sheet [.xls/.xlsx formats]",
        },
      ],
    },
    {
      cells: [{ value: "8" }, { value: "Upload progress to be shown" }],
    },
    {
      cells: [
        { value: "9" },
        {
          value: "Post upload, show progress bar for product creation",
        },
      ],
    },

    {
      cells: [
        { value: "10", bold: true },
        { value: "System validations to be in place:", bold: true },
      ],
    },
    {
      cells: ["", "Field specific validation"].map((v) => ({
        value: v,
      })),
    },
    {
      cells: ["", "Mandatory fields validation"].map((v) => ({
        value: v,
      })),
    },
    {
      cells: [
        "",
        "Dropdown values must match configured system values",
      ].map((v) => ({ value: v })),
    },
    {
      cells: [
        "",
        "Item ID exists → Update | Else → Create product",
      ].map((v) => ({ value: v })),
    },
    {
      cells: ["", "**RETAIN ALL VALIDATIONS FROM ADMIN UI"].map((v) => ({
        value: v,
        bold: true,
      })),
    },

    {
      cells: [
        { value: "11", bold: true },
        { value: "Post completion display:", bold: true },
      ],
    },
    {
      cells: ["", "Total records available"].map((v) => ({ value: v })),
    },
    { cells: ["", "Successfully created"].map((v) => ({ value: v })) },
    { cells: ["", "Failure"].map((v) => ({ value: v })) },
    {
      cells: ["", "Display failed records with reason"].map((v) => ({
        value: v,
      })),
    },
    {
      cells: [
        "",
        "Format: Import sheet row #, Item ID, Failed reason",
      ].map((v) => ({ value: v })),
    },

    {
      cells: [
        { value: "15", bold: true },
        {
          value: `Sheet "Configure_TemplateListValues" is protected & editable only for value list change`,
          bold: true,
        },
      ],
    },
  ],
}
export const instructionSheetAvalara = {
  name: "Instructions",
  columns: [{ width: 60 }, { width: 900 }],
  rows: [
    {
      height: 40,
      cells: [
        {
          value: "PRODUCT IMPORT – USER INSTRUCTION SHEET",
          bold: true,
          fontSize: 16,
          background: "#1E3A8A",
          color: "#FFFFFF",
          textAlign: "center",
          verticalAlign: "center",
          colSpan: 2,
        },
      ],
    },

    {
      cells: [
        "",
        "This sheet explains how to fill the Product Import Template correctly for bulk creation or update of product metadata in Master Data.",
      ],
    },

    { cells: ["", ""].map((v) => ({ value: v })) },

    {
      cells: [
        {
          value: "General Guidelines",
          bold: true,
        },
        "",
      ],
    },

    {
      cells: [
        "1",
        "This import sheet allows users to create or update product metadata in bulk.",
      ],
    },
    { cells: ["2", "Fields marked with “*” are mandatory."] },
    { cells: ["3", "Do not rename sheet names or column names."] },
    { cells: ["4", "Only .xls / .xlsx formats are allowed."] },
    {
      cells: [
        "5",
        "If Barcode Value exists, the system will update the product.",
      ],
    },
    {
      cells: [
        "6",
        "If Barcode Value does not exist, the system will create a new product.",
      ],
    },

    { cells: ["", ""].map((v) => ({ value: v })) },

    {
      cells: [
        {
          value: "How to Fill Each Column?",
          bold: true,
        },
        "",
      ],
    },

    { cells: ["1", "Product Name*"] },
    { cells: ["", "Alphanumeric, hyphens, spaces, and underscores allowed."] },
    { cells: ["", "Length must be 2 to 100 characters."] },

    { cells: ["", ""] },

    { cells: ["2", "Barcode Type*"] },
    { cells: ["", "Mandatory."] },
    { cells: ["", "Must match exactly with allowed system values."] },
    {
      cells: [
        "",
        "Supported Barcode Types: [EAN13, CODE128, DataMatrix, EAN-8, UPC-A, UPC-E, Code 39, Code 93, ITF-14, QR Code, PDF417, GS1-128, Aztec Code]",
      ],
    },

    { cells: ["", ""] },

    { cells: ["3", "Barcode*"] },
    { cells: ["", "Mandatory."] },
    { cells: ["", "Alphanumeric only."] },
    { cells: ["", "Length: 4 to 32 characters."] },

    { cells: ["", ""] },

    { cells: ["4", "Stock Code (SKU)*"] },
    { cells: ["", "Mandatory."] },
    { cells: ["", "Alphanumeric only."] },
    { cells: ["", "Length: 4 to 32 characters."] },

    { cells: ["", ""] },

    { cells: ["5", "Tax Code* (Conditional Mandatory)"] },
    { cells: ["", "Mandatory if Tax Provider = Some Tax Engine."] },
    { cells: ["", "Hidden if Tax Provider = Manual."] },
    { cells: ["", "Dropdown field."] },

    { cells: ["", ""] },

    { cells: ["6", "Gross Weight (g)*"] },
    { cells: ["", "Mandatory."] },
    { cells: ["", "Numeric only."] },
    { cells: ["", "Max 5 digits."] },
    { cells: ["", "Displayed in grams (g)."] },

    { cells: ["", ""] },

    { cells: ["7", "Weight Samples (g) – Optional"] },
    { cells: ["", "Numeric values only with * separator."] },
    { cells: ["", "Allowed number of samples: 1 to 15."] },
    { cells: ["", "Sample deviation must be ≤ 10%."] },
    {
      cells: [
        "",
        "User can enter manually OR system will auto-calculate if blank.",
      ],
    },

    { cells: ["", ""] },

    { cells: ["8", "Net Weight – Optional"] },
    { cells: ["", "Numeric only."] },
    { cells: ["", "Max 5 digits."] },

    { cells: ["", ""] },

    { cells: ["9", "Unit of Measure (UOM) – Optional"] },
    {
      cells: [
        "",
        "Supported UOM values: [grams, Bottle, Can, Box, Each, Piece, Pack, Case, Dozen, Kilogram, Milliliter, Liter, Pound, Ounce, Gallon, Meter, Centimeter, Inch, Foot, Bundle, Roll, Bag, Carton, Tray, Sleeve, Strip, Set, Kit]",
      ],
    },

    { cells: ["", ""] },

    { cells: ["10", "Item Storage – Optional"] },
    { cells: ["", "Allowed values: Normal or Cooler (Dropdown)."] },

    { cells: ["", ""] },

    { cells: ["11", "Product Dimensions (cm) – Optional"] },
    { cells: ["", "Numeric values only."] },
    { cells: ["", "Format: Height x Width x Depth (cm)."] },

    { cells: ["", ""] },

    { cells: ["12", "Brand – Optional"] },
    { cells: ["", "Alphanumeric."] },
    { cells: ["", "Length: 2 to 100 characters."] },

    { cells: ["", ""] },

    { cells: ["13", "Manufacturer – Optional"] },
    { cells: ["", "Alphanumeric."] },
    { cells: ["", "Length: 2 to 100 characters."] },
  ],
}
